import { Navigate, Outlet, Route } from "react-router";
import { Authenticated } from "@refinedev/core";
import { CatchAllNavigate } from "@refinedev/react-router";
import { ThemedLayoutV2 } from "@refinedev/mui";
import { ErrorComponent } from "@refinedev/mui";

import { Header } from "@shared/components/Header";

import { UserCreate, UserEdit, UsersList } from "@pages/users";
import {
  AgreementCreate,
  AgreementEdit,
  AgreementList,
} from "@pages/agreements";
import {
  AgreementPlanCreate,
  AgreementPlanEdit,
  AgreementPlansList,
} from "@pages/agreementPlans";
import { AgreementProductCreate } from "@pages/agreementProducts";
import { CatalogList } from "@pages/catalogs";
import { CategoryList } from "@pages/categorys";
import { ActivityList } from "@pages/activities";
import { BannerCreate, BannerEdit, BannerList } from "@pages/banners";
import { VoucherList } from "@pages/vouchers";
import { CompanyCreate, CompanyEdit, CompanyList } from "@pages/compenies";
import { StoreCreate, StoreEdit, StoreList } from "@pages/stores";
import { DiscountCreate, DiscountEdit, DiscountList } from "@pages/discounts";
import { CodeList } from "@pages/codes";
import { LevelList } from "@pages/levels";
import { DefaultPlanList } from "@pages/dafaultPlans";
import { PlanList } from "@pages/plans";
import { MapIntegrationPlanList } from "@pages/mapIntegrationPlans";
import { BookCreate, BookEdit, BookList } from "@pages/books";
import { AudioFileList } from "@pages/audioFiles";
import { BookCategoriesList } from "@pages/bookCategories";
import { BookActivitiesList } from "@pages/bookActivities";
import { BookAuthorsList } from "@pages/bookAuthors";
import { BookSectorList } from "@pages/bookSectors";
import { LandingsList, LandingCreate, LandingEdit } from "@pages/landings";
import { FluxPage } from "@pages/flux";
import { PromocodeBatchList } from "@pages/promocodeBatches";
import { PromocodeList } from "@pages/promocodes";
import { PrescriberList } from "@pages/prescribers";
import { UsageList } from "@pages/usages";
import { NotificationList, CreateNotification } from "@pages/notifications";
import { AgreementAppList, CreateAgreementApp } from "@pages/agreementApp";
import { MagazineTemplatesList } from "@pages/magazineTemplates";
import { BookMonthList } from "@pages/bookMonths";
import { SubscriptionList } from "@pages/subscriptions";
import { FinancialPage } from "@pages/financial";
import { EditAgreementApp } from "@pages/agreementApp/edit";
import { Integration } from "@pages/integration";
import { IntegrationBulk } from "@pages/integration/bulk";
import { IntegrationPlanMapping } from "@pages/integration/planMapping";
import { FolderGenerator } from "@pages/folderGenerator";
import { SyncReceivedBooks } from "@pages/syncReceivedBooks";
import { ErpIntegrations } from "@pages/erpIntegrations";
import { Dashboard } from "@pages/dashboard";
import { ProductList, ProductCreate, ProductEdit } from "@pages/products";
import { ReferralList } from "@pages/referrals/list";
import { ReceivedBookList } from "@pages/receivedBooks";
import { DownloadBookList } from "@pages/downloadBooks";
import {
  PartnersList,
  PartnerCreate,
  PartnerEdit,
  PartnerDetail,
  ReferralCreate,
  ReferralEdit,
} from "@pages/partners";


export const PrivateRoutes = (
  <Route
    element={
      <Authenticated
        key="authenticated-inner"
        fallback={<CatchAllNavigate to="/login" />}
      >
        <ThemedLayoutV2
          Title={({ collapsed }) => (
            <>
              <img
                src={
                  collapsed ? "/favicon.ico" : "/images/logo.png"
                }
                alt="Logo"
                style={{
                  width: collapsed ? "30px" : "100px",
                  height: "auto",
                  margin: "0 auto",
                }}
              />
            </>
          )}
          Header={Header}
        >
          <Outlet />
        </ThemedLayoutV2>
      </Authenticated>
    }
  >
    <Route index path="/" element={<Dashboard />} />
    <Route path="/integration" element={<Integration />} />
    <Route path="/integration/bulk" element={<IntegrationBulk />} />
    <Route path="/integration/plan-mapping" element={<IntegrationPlanMapping />} />
    <Route path="/folder-generator" element={<FolderGenerator />} />
    <Route path="/tools/sync-received-books" element={<SyncReceivedBooks />} />
    <Route path="/erp-integrations" element={<ErpIntegrations />} />
    <Route
      path="/tools/erp-integrations"
      element={<Navigate to="/erp-integrations" replace />}
    />
    <Route path="/users">
      <Route index element={<UsersList />} />
      <Route path="create" element={<UserCreate />} />
      <Route path="edit/:id" element={<UserEdit />} />
    </Route>

    <Route path="/agreement">
      <Route index element={<AgreementList />} />
      <Route path="create" element={<AgreementCreate />} />
      <Route path="edit/:id" element={<AgreementEdit />} />
    </Route>

    <Route path="/agreements/:agreementId/products">
      <Route path="create" element={<AgreementProductCreate />} />
    </Route>

    <Route path="/agreement_plans">
      <Route index element={<AgreementPlansList />} />
      <Route path="create" element={<AgreementPlanCreate />} />
      <Route path="edit/:id" element={<AgreementPlanEdit />} />
    </Route>

    <Route path="/catalogs" element={<CatalogList />} />
    <Route path="/categorys" element={<CategoryList />} />

    <Route path="/companies">
      <Route index element={<CompanyList />} />
      <Route path="create" element={<CompanyCreate />} />
      <Route path="edit/:id" element={<CompanyEdit />} />
    </Route>

    <Route path="/stores">
      <Route index element={<StoreList />} />
      <Route path="create" element={<StoreCreate />} />
      <Route path="edit/:id" element={<StoreEdit />} />
    </Route>

    <Route path="/discounts">
      <Route index element={<DiscountList />} />
      <Route path="create" element={<DiscountCreate />} />
      <Route path="edit/:id" element={<DiscountEdit />} />
    </Route>

    <Route path="/limited_code" element={<CodeList />} />
    <Route path="/activities" element={<ActivityList />} />

    <Route path="/banners">
      <Route index element={<BannerList />} />
      <Route path="create" element={<BannerCreate />} />
      <Route path="edit/:id" element={<BannerEdit />} />
    </Route>

    <Route path="/vouchers" element={<VoucherList />} />
    <Route path="/levels" element={<LevelList />} />
    <Route path="/default-plans" element={<DefaultPlanList />} />
    <Route path="/subscription-plan" element={<PlanList />} />
    <Route path="/subscriptions" element={<SubscriptionList />} />
    <Route path="/financial" element={<FinancialPage />} />
    <Route path="/integration-plans" element={<MapIntegrationPlanList />} />
    <Route path="/products">
      <Route index element={<ProductList />} />
      <Route path="create" element={<ProductCreate />} />
      <Route path="edit/:id" element={<ProductEdit />} />
    </Route>

    <Route path="/books">
      <Route index element={<BookList />} />
      <Route path="create" element={<BookCreate />} />
      <Route path="edit/:id" element={<BookEdit />} />
    </Route>

    <Route path="/audiobooks" element={<AudioFileList />} />
    <Route path="/book-categories" element={<BookCategoriesList />} />
    <Route path="/book-activities" element={<BookActivitiesList />} />
    <Route path="/book-authors" element={<BookAuthorsList />} />
    <Route path="/book-sectors" element={<BookSectorList />} />

    <Route path="/landings">
      <Route index element={<LandingsList />} />
      <Route path="create" element={<LandingCreate />} />
      <Route path="edit/:id" element={<LandingEdit />} />
    </Route>

    <Route path="/flux" element={<FluxPage />} />
    <Route path="/promocodes" element={<PromocodeList />} />
    <Route path="/promocode-batches" element={<PromocodeBatchList />} />
    <Route path="/prescribers" element={<PrescriberList />} />
    <Route path="/usages" element={<UsageList />} />
    <Route path="/magazine-templates" element={<MagazineTemplatesList />} />
    <Route path="/book-months" element={<BookMonthList />} />

    <Route path="/notifications">
      <Route index element={<NotificationList />} />
      <Route path="create" element={<CreateNotification />} />
    </Route>

    <Route path="/agreement-apps">
      <Route index element={<AgreementAppList />} />
      <Route path="create" element={<CreateAgreementApp />} />
      <Route path="edit/:id" element={<EditAgreementApp />} />
    </Route>

    <Route path="/referrals">
      <Route index element={<ReferralList />} />
    </Route>

    <Route path="/received-books" element={<ReceivedBookList />} />
    <Route path="/download-books" element={<DownloadBookList />} />

    <Route path="/partners">
      <Route index element={<PartnersList />} />
      <Route path="create" element={<PartnerCreate />} />
      <Route path="edit/:id" element={<PartnerEdit />} />
      <Route path="detail/:id" element={<PartnerDetail />} />
      <Route path="referrals/create" element={<ReferralCreate />} />
      <Route path="referrals/edit/:id" element={<ReferralEdit />} />
    </Route>

    <Route path="*" element={<ErrorComponent />} />
  </Route>
);
